import { useTranslation } from 'next-i18next';
import React, { ReactElement } from 'react';
import { AuthChannelType } from '@hotelplan/fdr.lib.ident.auth-config';
import { useAuthentication } from '@hotelplan/fdr.lib.ident.with-auth';
import {
  FdrCO2DescriptionTextMain,
  FdrCO2DescriptionTextSub,
  FdrCO2FootprintTitle,
} from './fdr-co2-footprint.styles';

interface IFdrCo2FootprintDescriptionProps {
  totalEmission: number;
}

export function FdrCo2FootprintDescription({
  totalEmission,
}: IFdrCo2FootprintDescriptionProps): ReactElement {
  const [t] = useTranslation('pdp');
  const { channelType } = useAuthentication();
  const isB2b = channelType === AuthChannelType.B2B;

  return (
    <>
      <FdrCO2FootprintTitle>
        {t('pdp:co2Footprint.descriptionTitle')}
      </FdrCO2FootprintTitle>
      <FdrCO2DescriptionTextMain
        dangerouslySetInnerHTML={{
          __html: t(
            `pdp:co2Footprint.${
              isB2b ? 'descriptionTextMainB2b' : 'descriptionTextMain'
            }`
          ),
        }}
      />
      <FdrCO2DescriptionTextMain
        dangerouslySetInnerHTML={{
          __html: t('pdp:co2Footprint.descriptionTextMain2', {
            emission: totalEmission.toString().replace('.', ','),
          }),
        }}
      />
    </>
  );
}
